import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/shared/components/page-header';
import { Button } from '@/shared/ui/button';
import { Card } from '@/shared/ui/card';
import { Skeleton } from '@/shared/ui/skeleton';
import type { IntegrationProvider } from '@/shared/types/nps';
import { ArrowLeft } from 'lucide-react';
import { useAvailableProviders } from '../api/use-nps';
import { ProviderLogo } from './provider-logo';
import { IntegrationConnectDialog } from '../components/integrations/integration-connect-dialog';

/** Página dedicada de criação/seleção de integração. */
export function IntegrationsCreatePage() {
  const navigate = useNavigate();
  const { data: providers = [], isLoading } = useAvailableProviders();
  const [selected, setSelected] = useState<IntegrationProvider | null>(null);

  return (
    <>
      <PageHeader
        title="Nova integração"
        description="Selecione um provedor para conectar sua loja."
        actions={
          <Button variant="secondary" onClick={() => navigate('/nps/integracoes')}>
            <ArrowLeft className="size-4" /> Voltar
          </Button>
        }
      />

      {isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-36 rounded-2xl" />)}
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {providers.map((p) => (
            <Card
              key={p.id}
              role="button"
              tabIndex={0}
              onClick={() => setSelected(p)}
              onKeyDown={(e) => e.key === 'Enter' && setSelected(p)}
              className="flex cursor-pointer flex-col items-center gap-3 p-6 transition-shadow hover:shadow-glass-sm"
            >
              <ProviderLogo type={p.type} size={56} />
              <span className="text-sm font-semibold">{p.name}</span>
            </Card>
          ))}
        </div>
      )}

      <IntegrationConnectDialog
        provider={selected}
        open={Boolean(selected)}
        onOpenChange={(o) => !o && setSelected(null)}
        onConnected={() => navigate('/nps/integracoes')}
      />
    </>
  );
}
